import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import "./PrivacyPolicy.css";

export function PrivacyPolicy() {
  const navigate = useNavigate();

  return (
    <div
      className="privacy-page-wrapper"
      style={{ backgroundImage: "url(/Group4.svg)" }}
    >
      <div className="header-actions">
        <div>
          <a
            style={{ margin: 0, padding: 0 }}
            onClick={() => navigate("/")}
            className="back-home"
          >
            <ChevronLeft size={18} />
            Back
          </a>
        </div>
      </div>
      <div className="privacy-page-body">
        <h1
          style={{ fontSize: "2.5rem", marginBottom: "24px", color: "white" }}
        >
          Privacy Policy
        </h1>
        <p style={{ color: "var(--text-secondary)", marginBottom: "32px" }}>
          Last Updated: April 28, 2026
        </p>

        <section style={{ marginBottom: "40px" }}>
          <h2
            style={{ fontSize: "1.5rem", marginBottom: "16px", color: "white" }}
          >
            1. Introduction
          </h2>
          <p style={{ lineHeight: "1.6", color: "var(--text-secondary)" }}>
            Findmore Solutions is committed to protecting your
            privacy. This Privacy Policy explains how we collect, use, and
            safeguard your information when you use our website and AI chat
            tool.
          </p>
        </section>

        <section style={{ marginBottom: "40px" }}>
          <h2
            style={{ fontSize: "1.5rem", marginBottom: "16px", color: "white" }}
          >
            2. Information We Collect
          </h2>
          <p style={{ lineHeight: "1.6", color: "var(--text-secondary)" }}>
            <strong>a. Chat Data:</strong> When you use our AI Explorer, the
            messages you input are processed to provide AI-generated responses.
          </p>
          <p style={{ lineHeight: "1.6", color: "var(--text-secondary)" }}>
            <strong>b. Analytics:</strong> We use Google Analytics and Microsoft
            Clarity to collect information about how users interact with our site
            (e.g., pages visited, time spent, clicks, and scroll behavior). This
            data is anonymized.
          </p>
        </section>

        <section style={{ marginBottom: "40px" }}>
          <h2
            style={{ fontSize: "1.5rem", marginBottom: "16px", color: "white" }}
          >
            3. How We Use Your Data
          </h2>
          <p style={{ lineHeight: "1.6", color: "var(--text-secondary)" }}>
            Data collected is used to:
          </p>
          <ul style={{ color: "var(--text-secondary)", lineHeight: "1.8" }}>
            <li>Provide and improve the AI Explorer services.</li>
            <li>Analyze website traffic and user behavior.</li>
            <li>Ensure the security and integrity of our platform.</li>
          </ul>
        </section>

        <section style={{ marginBottom: "40px" }}>
          <h2
            style={{ fontSize: "1.5rem", marginBottom: "16px", color: "white" }}
          >
            4. Data Sharing and Third Parties
          </h2>
          <p style={{ lineHeight: "1.6", color: "var(--text-secondary)" }}>
            We share data with the following third-party providers:
          </p>
          <p style={{ lineHeight: "1.6", color: "var(--text-secondary)" }}>
            <strong>OpenAI:</strong> Chat inputs are sent to OpenAI's servers to
            generate responses. OpenAI does not use this data to train their
            models when using their Enterprise/API services.
          </p>
          <p style={{ lineHeight: "1.6", color: "var(--text-secondary)" }}>
            <strong>Google:</strong> Anonymized usage data is shared with Google
            Analytics for performance tracking.
          </p>
          <p style={{ lineHeight: "1.6", color: "var(--text-secondary)" }}>
            <strong>Microsoft:</strong> Anonymized usage and interaction data
            (such as clicks, scroll depth, and session recordings) is shared
            with Microsoft Clarity for user experience analysis.
          </p>
        </section>

        <section style={{ marginBottom: "40px" }}>
          <h2
            style={{ fontSize: "1.5rem", marginBottom: "16px", color: "white" }}
          >
            5. GDPR Rights
          </h2>
          <p style={{ lineHeight: "1.6", color: "var(--text-secondary)" }}>
            Under GDPR, users in the EU have the following rights:
          </p>
          <ul style={{ color: "var(--text-secondary)", lineHeight: "1.8" }}>
            <li>Right to access your data.</li>
            <li>Right to rectification or erasure.</li>
            <li>Right to restrict or object to processing.</li>
            <li>Right to data portability.</li>
          </ul>
          <p style={{ lineHeight: "1.6", color: "var(--text-secondary)" }}>
            To exercise these rights, please contact us at privacy@findmore.com.
          </p>
        </section>

        <footer
          style={{
            borderTop: "1px solid var(--card-border)",
            paddingTop: "24px",
            marginTop: "60px",
            color: "var(--text-secondary)",
            fontSize: "0.9rem",
          }}
        >
          &copy; 2026 Findmore. All rights reserved.
        </footer>
      </div>
    </div>
  );
}

{
  /*
  
      <div className="landing-page-wrapper" style={{ backgroundImage: 'url(/Group4.svg)' }}>
      <div className="landing-page">
        <button
          onClick={() => navigate(-1)}
          className="back-home"
          style={{
            justifyContent: 'flex-start',
            marginBottom: '32px',
            color: 'var(--accent-blue)',
            padding: 0
          }}
        >
          <ChevronLeft size={20} /> Back
        </button>

        
      </div>
    </div>
  
  */
}
